export enum AvailableCountry {
  'fr' = 'fr',
  'de' = 'de',
  'ch' = 'ch',
  'be' = 'be',
  'es' = 'es',
  'nl' = 'nl',
  'lu' = 'lu',
  'it' = 'it',
}

export enum CountryCode {
  FR = 'fr',
  DE = 'de',
  CH = 'ch',
  BE = 'be',
  ES = 'es',
  NL = 'nl',
  LU = 'lu',
  IT = 'it',
  GP = 'gp',
  GF = 'gf',
  MQ = 'mq',
  RE = 're',
  NC = 'nc',
  PF = 'pf',
  PM = 'pm',
  WF = 'wf',
  MC = 'mc',
}
